
<div id="">
   <header id="banner" role="banner">
      <nav class="site-breadcrumbs" id="breadcrumbs">
         <!--<h1> <span>Elementi Navigazione</span> </h1>--> 
         <ul class="breadcrumbs breadcrumbs-horizontal lfr-component">
            <li class="first"><span><a routerLink="">SIRA</a></span></li>
            <li class="last"><span><a routerLink="homeprivata">HOME PRIVATA</a></span></li>
         </ul>
      </nav>
   </header>
   <div id="content">
      <div class="portlet-boundary portlet-boundary_103_ portlet-static portlet-static-end " id="p_p_id_103_">
         <span id="p_103"></span> 
         <div class="portlet-body"> </div>
<!--<div (click)="getTestRestResponce()">DEBUGGING: 2 be removed</div>-->
      </div>
      <div class="columns-2" id="main-content" role="main">
         <div class="portlet-layout">
            <div class="aui-w50 portlet-column portlet-column-first" id="column-1">
               <div class="portlet-dropzone portlet-column-content portlet-column-content-first" id="layout-column_column-1">
                  <!-- SCRIVANIA DEL CITTADINO -->
                  <div class="portlet-body">
                     <section class="portlet" id="portlet_SIRATematismi_WAR_SIRATematismiportlet" style="padding: 15px;">
                        <div class="portlet-boundary portlet-boundary_56_ portlet-borderless portlet-journal-content  portlet-draggable" id="p_p_id_56_INSTANCE_jHYcUbtVbju5_">
                           <span id="p_56_INSTANCE_jHYcUbtVbju5"></span> 
                           <div class="portlet-body">
                              <div class="portlet-borderless-container" style="">
                                 <div class="portlet-body">
                                    <div class="journal-content-article">
                                       <p> <img src="https://test.sardegnasira.it/GPAtools/images/soggettoFisico.png" style="width: 32px; height: 32px; vertical-align: middle;"><span style="font-size:21px;"><strong style="vertical-align: middle;"> <span>Scrivania del Cittadino</span></strong></span></p>
                                       <p> Nella sezione sono disponibili le funzionalità esposte dal <em><strong>Modulo Gestione Procedimenti Amministrativi</strong></em> (<em>GPA</em>).</p>
                                       <p> Le funzionalità sono filtrate sulla base delle abilitazioni dell'utente.</p>
                                       <hr>
                                       <p> &nbsp;</p>
                                       <table align="center" border="0" cellpadding="1" cellspacing="1" style="width: 80%; padding-left: 20px; padding-right: 20px; font-size:16px;">
                                          <tbody>
                                             <tr>
                                                <td style="text-align: center; vertical-align: middle;" width="50%">
                                                   <div class="button-linear-grey"> <a href="https://test.sardegnasira.it/GPAtools/flow/createNewProcessInstance" style="text-decoration: none;" target="_blank" title="Crea nuovo procedimento">Crea nuovo procedimento</a></div>
                                                </td>
                                                <td style="text-align: center; vertical-align: middle;" width="50%">
                                                   <div class="button-linear-grey"> <a href="https://test.sardegnasira.it/GPAtools/flow/scadenzario" style="text-decoration: none;" title="Scadenzario">Scadenzario</a></div>
                                                </td>
                                             </tr>
                                             <tr>
                                                <td colspan="2" style="text-align: center; vertical-align: middle;" width="50%">
                                                   <div class="button-linear-grey"> <a href="https://test.sardegnasira.it/GPAtools/flow/leMiePraticheRev1" style="text-decoration: none;" title="Le mie pratiche"><img src="/documents/10179/0/Siti+contaminati/976c23ab-23ff-4642-aa47-f03740e729f6?t=1539254743211" style="width: 32px; height: 32px; vertical-align: middle;" title=""> Le mie pratiche</a></div>
                                                </td>
                                             </tr>
                                             <tr>
                                                <td colspan="2" style="text-align: center; vertical-align: middle;" width="50%">
                                                   <div class="button-linear-grey"> <a href="https://test.sardegnasira.it/GPAtools/flow/ricercaFontiUtente" style="text-decoration: none;" title="Ricerca Fonti">Ricerca Fonti</a></div>
                                                </td>
                                             </tr>
                                          </tbody>
                                       </table>
                                    </div>
                                 </div>
                              </div>
                           </div>
                        </div>
                        <div class="portlet-boundary portlet-boundary_56_ portlet-borderless portlet-journal-content  portlet-draggable" id="p_p_id_56_INSTANCE_AoA1VBjQuPDu_">
                           <span id="p_56_INSTANCE_AoA1VBjQuPDu"></span> 
                           <div class="portlet-body">
                              <div class="portlet-borderless-container" style="">
                                 <div class="portlet-body">
                                    <div class="journal-content-article">
                                       <table align="center" border="0" cellpadding="1" cellspacing="1" style="width: 80%; padding-left: 20px; padding-right: 20px; font-size:16px;">
                                          <tbody>
                                             <tr>
                                                <td colspan="2" style="text-align: center; vertical-align: middle;" width="50%">
                                                   <div class="button-linear-grey"> <a href="https://test.sardegnasira.it/orso" style="text-decoration: none;" target="_blank" title="Ricerca Fonti">Dichiarazione Rifiuti Urbani</a></div>
                                                </td>
                                             </tr>
                                          </tbody>
                                       </table>
                                       <hr>
                                    </div>
                                 </div>
                              </div>
                           </div>
                        </div>
                     </section>
                  </div>
                  <!-- TEMATISMI -->
                  <div class="portlet-body" *ngIf="areetematiche && areetematiche.length">
                     <section class="portlet" id="portlet_SIRATematismi_WAR_SIRATematismiportlet">
                        <table style="width: 100%;">
                           <tbody>
                              <tr>
                                 
                                 <td>
                                    <header class="portlet-topper gradient">
                                       <h1 class="portlet-title"> <span class="portlet-title-text" style="margin-left: 0px;">SIRA Tematismi</span> </h1>
                                    </header>
                                 </td>
                              </tr>
                           </tbody>
                        </table>
                        <div class="portlet-content">
                           <div class=" portlet-content-container">
                              <div class="portlet-body">
                                 <hr style="border-top: dotted 1px;">
                                 <div id="tematismiContent">
                                    Tematismi abilitati per l'utente <b>{{getUsername()}}</b>: 
                                    <hr style="border-top: dotted 1px;">
                                    <ul>
                                       <li *ngFor="let menuitem of areetematiche">
                                          <div (click)="toggleSubSection(divsub)" class="menuItem">
                                                <mat-icon class="icon">{{menuitem.icon}}</mat-icon>
                                                {{menuitem.label}}
                                          </div>
                                          <div #divsub [hidden]="true" class="divSub">
                                          <div *ngFor="let menusubitem of menuitem.children">
                                                <p>
                                                   <span class="divSubTitle"> "<strong>{{menusubitem.label}}</strong>". </span> 
                                                </p>
                                                <ul>
                                                   <li *ngIf="!menusubitem.children.length">
                                                      <mat-icon class="lefticon">{{menusubitem.icon}}</mat-icon>
                                                      <a *ngIf="menusubitem.href != null" [href]="menusubitem.href" [target]="menusubitem.behavior" class="inlineblock" [title]="menusubitem.title">{{menusubitem.label}}</a>
                                                      <a *ngIf="menusubitem.route != null" [routerLink]="menusubitem.route" class="inlineblock" [title]="menusubitem.title">{{menusubitem.label}}</a>

                                                      <mat-icon class="righticon">{{menusubitem.icon2}}</mat-icon>
                                                      <a *ngIf="menusubitem.route2 != null" routerLink="viewcomp" [state]="{ url: menusubitem.route2 }" class="inlineblock" [title]="menusubitem.title2">{{menusubitem.label2}}</a>
                                                      <a *ngIf="menusubitem.href2 != null" [href]="menusubitem.href2" [target]="menusubitem.behavior2" class="inlineblock" [title]="menusubitem.title2">{{menusubitem.label2}}</a>
                                                   </li>
                                                   <li *ngFor="let menusubsubitem of menusubitem.children">
                                                      <div style="display: inline-block">
                                                         <mat-icon class="lefticon">{{menusubsubitem.icon}}</mat-icon>
                                                         <a *ngIf="menusubsubitem.href != null" [href]="menusubsubitem.href" [target]="menusubsubitem.behavior" class="inlineblock" [title]="menusubsubitem.title2">{{menusubsubitem.label}}</a>
                                                         <a *ngIf="menusubsubitem.route != null" [routerLink]="menusubsubitem.route" class="inlineblock" [title]="menusubsubitem.title2">{{menusubsubitem.label}}</a>
                                                      </div>
                                                      <div style="display: inline-block">
                                                         <mat-icon class="righticon">{{menusubsubitem.icon2}}</mat-icon>
                                                         <a *ngIf="menusubsubitem.route2 != null" routerLink="viewcomp" [state]="{ url: menusubsubitem.route2 }" class="inlineblock" [title]="menusubsubitem.title2">{{menusubsubitem.label2}}</a>
                                                         <a *ngIf="menusubsubitem.href2 != null" [href]="menusubsubitem.href2" [target]="menusubsubitem.behavior2" class="inlineblock" [title]="menusubsubitem.title2">{{menusubsubitem.label2}}</a>
                                                      </div>
                                                   </li>
                                                </ul>
                                          </div>
                                 </div>
                                 </li>
                                 </ul>
                              </div>
                           </div>
                        </div>
                  </div>
                  </section>
               </div>
            </div>
         </div>
         <div class="aui-w50 portlet-column portlet-column-last" id="column-2">
            <div class="portlet-dropzone portlet-column-content portlet-column-content-last" id="layout-column_column-2">
               <!-- MAPPA -->
               <!-- XXX fracobollo -->			   
               <div class="portlet-body">
                  <section class="portlet" id="portlet_Francobollo_WAR_Francobolloportlet">
                     <table style="width: 100%;">
                        <tbody>
                           <tr>
                              
                              <td>
                                 <header class="portlet-topper gradient">
                                    <h1 class="portlet-title"> <span class="portlet-title-text" style="margin-left: 0px;">Francobollo</span> </h1>
                                 </header>
                              </td>
                           </tr>
                        </tbody>
                     </table>
                     <div class="portlet-content">
                        <div class=" portlet-content-container" style="">
                           <div class="portlet-body">
                              <meta http-equiv="Content-Type" content="text/html; charset=utf-8">
                              <meta http-equiv="X-UA-Compatible" content="IE=7, IE=9, IE=10">
                              <!-- The viewport meta tag is used to improve the presentation and behavior of the samples on iOS devices --> 
                              <meta name="viewport" content="initial-scale=1, maximum-scale=1,user-scalable=no">
                              <title>Mini Mappa</title>
                              <!-- Esri stuff --> 
                              <link rel="stylesheet" type="text/css" href="https://js.arcgis.com/4.11/esri/themes/light/main.css">
                              <style> #map { padding: 0; margin: 0px; height: 100%; width: 100%; overflow: hidden; position: relative; } #LocateButton { position: absolute; top: 110px; left: 22px; z-index: 50; } #HomeButton { position: absolute; top: 150px; left: 22px; z-index: 51; } #BasemapToggle { position: absolute; top: 20px; right: 20px; z-index: 52; } .shadow { -moz-border-radius: 20px; -webkit-border-radius: 20px; border-radius: 20px; -moz-box-shadow: 0 20px 10px -10px #bdbdbd; -webkit-box-shadow: 0 20px 10px -10px #bdbdbd; box-shadow: 0 10px 10px -10px #bdbdbd; background-color: #FFF; padding: 18px; } .map .logo-sm { display: none; } .esriAttribution { display: none; } </style>
                              <div id="map" class="shadow map" style="border: 1px solid rgb(136, 136, 136); height: 400px;" data-basemap="hybrid" data-zoom="7" data-scale="4622324.434309" data-loaded="">
                                 <app-esri-map style="height: 100%; "
                                 [center]="mapCenter"
                                 [basemap]="basemapType"
                                 [zoom]="mapZoomLevel"
                                 (mapLoadedEvent)="mapLoadedEvent($event)">
                                 </app-esri-map>
                              </div>
                           </div>
                        </div>
                     </div>
                  </section>
               </div>
               <!-- CONTATTI -->				  
               <div class="portlet-body">
                  <section class="portlet" id="portlet_56_INSTANCE_D5vw3e6lVQe5">
                     <table style="width: 100%;">
                        <tbody>
                           <tr>
                              
                              <td>
                                 <header class="portlet-topper gradient">
                                    <h1 class="portlet-title"> <span class="portlet-title-text" style="margin-left: 0px;">CONTATTI SIRANET</span> </h1>
                                 </header>
                              </td>
                           </tr>
                        </tbody>
                     </table>
                     <div class="portlet-content">
                        <div class=" portlet-content-container" style="">
                           <div class="portlet-body">
                              <div class="journal-content-article"> Procedi alla sezione <a routerLink="contattaci">Contatti</a> del <span style="color:#0066cc;"><strong>SIRA</strong></span>net, per gli estremi di comunicazione. </div>
                              <br>
                           </div>
                        </div>
                     </div>
                  </section>
               </div>
               <!-- XXX NORMATIVA -->
               <div class="portlet-body">
                  <section class="portlet" id="portlet_56_INSTANCE_mnCO9CwzVO9H">
                     <table style="width: 100%;">
                        <tbody>
                           <tr>
                              
                              <td>
                                 <header class="portlet-topper gradient">
                                    <h1 class="portlet-title"> <span class="portlet-title-text" style="margin-left: 0px;">Normativa</span> </h1>
                                 </header>
                              </td>
                           </tr>
                        </tbody>
                     </table>
                     <div class="portlet-content">
                        <div class=" portlet-content-container" style="">
                           <div class="portlet-body">
                              <div class="journal-content-article"> Procedi alla sezione <a href="https://test.sardegnasira.it/normativa" target="_blank">Normativa</a> del <span style="color:#0066cc;"><strong>SIRA</strong></span>net per la consultazione. </div>
                              <br> 
                           </div>
                        </div>
                     </div>
                  </section>
               </div>
            </div>
         </div>
      </div>
   </div>
</div>
</div>